import { Box, Stack } from '@mui/material';

import AccountInfoMini from '../account-info-mini';
import NavListMini from '../nav-list-mini';

const SiderBarMiniContent = () => {
  return (
    <Stack
      gap={4}
      sx={{
        top: 0,
        left: 0,
        position: 'fixed',
        height: '100vh',
        overflow: 'auto',
        scrollbarWidth: 'thin',
      }}
    >
      <Stack sx={{ px: 0.5, pt: 2, alignItems: 'center' }}>
        <Box
          component="img"
          alt="logo"
          src="/assets/logo.png"
          sx={{ width: 65, objectFit: 'scale-down' }}
        />
      </Stack>
      <Stack gap={2} sx={{ px: 1 }}>
        <AccountInfoMini />
        <NavListMini />
      </Stack>
    </Stack>
  );
};

export default SiderBarMiniContent;
